
// import { Button } from '../../../components/base/Button';

const FarInfraredHeroSection = () => {
  return (
    <section className="relative py-10 bg-[#FCF8F8] flex items-center">
      <div className="container max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 className="text-xl lg:text-2xl font-bold text-[#00889D] leading-tight">
              Far Infrared Heat: Next Level of Wellness
            </h1>

            <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
              <p>
                We elevate your yoga and fitness experience with the gentle, therapeutic
                energy of <span className="text-[#00889D] font-semibold">Far Infrared (FIR)</span> heat —a form of
                radiant energy that’s invisible
                to the eye yet deeply effective. Unlike traditional heating systems that warm
                the air, FIR gently heats your body directly and penetrating deep into
                muscles and joints to promote natural warmth, flexibility, and recovery. The
                result is a soothing, detoxifying environment that enhances every movement
                and breath without the heavy, stifling air of conventional hot studios. What
                makes far infrared unique:
              </p>
            </div>

            {/* Three Benefits with Icons */}
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="text-center space-y-4">
                <div className="w-12 h-12 mx-auto flex items-center justify-center">
                  <i className="ri-fire-fill text-3xl text-[#00889D]"></i>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  FIR gently raises your core temperature from within, creating a balanced, breathable warmth that supports both endurance and relaxation.
                </p>
              </div>

              <div className="text-center space-y-4">
                <div className="w-12 h-12 mx-auto flex items-center justify-center">
                  <i className="ri-fire-fill text-3xl text-[#00889D]"></i>
                  <i className="ri-fire-fill text-3xl text-[#00889D] ml-1"></i>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  The longer wavelengths of infrared energy reach beneath the skin’s surface to relieve muscle tension, ease stiffness, and improve circulation.
                </p>
              </div>

              <div className="text-center space-y-4">
                <div className="w-12 h-12 mx-auto flex items-center justify-center">
                  <i className="ri-fire-fill text-3xl text-[#00889D]"></i>
                  <i className="ri-fire-fill text-3xl text-[#00889D] ml-1"></i>
                  <i className="ri-fire-fill text-3xl text-[#00889D] ml-1"></i>
                </div>
                <p className="text-sm text-gray-600 leading-relaxed">
                  Practicing in infrared heat helps detoxify the body, boost metabolism,
                  and reduce stress-leaving you feeling deeply recharged and restored.
                </p>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="lg:order-last">
            <img
              src="/img/far-infrared-bg.png"
              alt="Far Infrared Heat Therapy"
              className="w-full h-auto rounded-3xl shadow-2xl object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FarInfraredHeroSection;
